export const bizNoFormat = (bizNo: string) => {
  if (bizNo.length == 10) {
    bizNo = bizNo.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
  }

  return bizNo;
};

export const telNoFormat = (num: string) => {
  if (num.substring(0, 1) == "0") {
    if (num.substring(0, 2) == "02") {
      if (num.length == 10) {
        num = num.substring(0, 2) + "-" + num.substring(2, 6) + "-" + num.substring(6, 10);
      } else if (num.length == 9) {
        num = num.substring(0, 2) + "-" + num.substring(2, 5) + "-" + num.substring(5, 9);
      }
    } else {
      if (num.length == 10) {
        num = num.substring(0, 3) + "-" + num.substring(3, 6) + "-" + num.substring(6, 10);
      } else if (num.length == 11) {
        num = num.substring(0, 3) + "-" + num.substring(3, 7) + "-" + num.substring(7, 11);
      }
    }
  } else {
    if (num.length == 8) {
      num = num.substring(0, 4) + "-" + num.substring(4, 8);
    }
  }
  return num;
};

export const phoneNumberChk = (number: string) => {
  if (number.length == 11) {
    const result = /^(010)-?[0-9]{4}-?[0-9]{4}$/;
    return result.test(number);
  }
  return false;
};
